import { useState } from "react";
import { examSessions, examSessions1 } from "../../_helpers/exams";
import classNames from "classnames";


export const PersonalTimeTable = () => {

    const [srcWrd, setSrcWrd] = useState('');

    return (
        <div className="page-body">
            <div className="search">
                <input
                    value={srcWrd}
                    onChange={(e) => setSrcWrd(e.target.value)}
                    placeholder="Teacher name"
                    className="nm"
                />
                <button className="src-btn">Search</button>
            </div>
            <div className="levels-label">
                <div className="levels-cap">ORDINARY LEVEL</div>
                <div className="levels-cap">ADVANCED LEVEL</div>
            </div>
            <div className="levels">
                <div className="level-cont">
                <div className="session-container">
                    <strong>MORNING</strong>
                </div>
                <div className="session-container">
                    <strong>AFTERNOON</strong>
                </div>
                    {examSessions.map((data) => {

                        return (
                            
                                <div className="session-container">
                                    <div className="date-label-t">
                                        <div className="eval">
                                            {data.date}
                                            {data.invigilators.map((inv) => (
                                                <span 
                                                    className={classNames(
                                                        "inv-name",
                                                        {'res1': srcWrd?.toLowerCase() === inv.toLocaleLowerCase()}
                                                    )}
                                                >
                                                    {inv}
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                    
                                    
                                </div>
                        )
                    })}
                </div>
                <div className="level-cont">
                    <div className="session-container">
                        <strong>MORNING</strong>
                    </div>
                    <div className="session-container">
                        <strong>AFTERNOON</strong>
                </div>
                    {examSessions1.map((data) => {

                        return (
                            
                                <div className="session-container">
                                    <div className="date-label-t">
                                        <div className="eval">{data.date}
                                            {data.invigilators.map((inv) => (
                                                <span 
                                                    className={classNames(
                                                        "inv-name",
                                                        {'res1': srcWrd.toLowerCase() === inv.toLocaleLowerCase()}
                                                    )}
                                                >
                                                    {inv}
                                                </span>
                                            ))}
                                        </div>
                                    </div>                    
                                </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}